export const formElementProps = {
    noMargin: Boolean,
    error: Boolean,
    errorMessage: String,
};
